import { FC } from 'react';

type onCloseMenuItem = (id: string) => void;

export default function DynamicMenuItemComponent({
  component,
  onClose,
}: Readonly<{
  component: FC<{ onClose?: onCloseMenuItem }>;
  onClose?: onCloseMenuItem;
}>) {
  const SelectedComponent = component;
  return <SelectedComponent onClose={onClose} />;
}
